import TableContent from "./content/table-content.jsx";
import OccurrenceNature from "./content/occurrence-nature.jsx";
import RegisterMethod from "./content/register-method.jsx";
import OccurrenceNeighborhood from "./content/occurrence-neighborhood.jsx";
import OccurrenceHistory from "./content/occurrence-history.jsx";
import OccurrenceByDay from "./content/occurrence-by-day.jsx";
import OccurrenceDayWeek from "./content/occurrence-day-week.jsx";
import ProfileCard from "./content/profile-card.jsx";

export default function ReportContent({ data, collapsed, tableMode, setMode }) {
    const totalOccurrences = data?.allOccurrences?.[0].totaloccurrences;

    return (
        <>
            { tableMode ? (
                <TableContent data={data}/>
            ) : (
                <>
                    <div id="general">
                        <div className="report-divisor mb-3">
                            <span className="divisor-title">
                                VISÃO GERAL
                                <span className="sub-title-info-no-hover no-hover! print:hidden">Total ocorrências: {totalOccurrences}</span>
                            </span>
                        </div>

                        <OccurrenceNature data={data} key={`OccurrenceNatureKey-${collapsed}`} setMode={setMode}/>
                        <RegisterMethod data={data} key={`RegisterMethodKey-${collapsed}`} setMode={setMode}/>
                        <OccurrenceNeighborhood data={data} key={`OccurrenceNeighborhoodKey-${collapsed}`} setMode={setMode}/>
                    </div>

                    <section>
                        <div className="report-divisor mt-7 mb-3 print:break-after-avoid!">
                            <span className="divisor-title">ANÁLISE TEMPORAL</span>
                        </div>

                        <OccurrenceHistory data={data} key={`OccurrenceHistoryKey-${collapsed}`} setMode={setMode}/>
                        <OccurrenceByDay data={data} key={`OccurrenceByDayKey-${collapsed}`} setMode={setMode}/>
                        <OccurrenceDayWeek data={data} key={`OccurrenceWeekDayKey-${collapsed}`} setMode={setMode}/>
                    </section>

                    <ProfileCard data={data} key={`ProfileCardKey-${collapsed}`} setMode={setMode}/>
                </>
            )}

            <div id="chart-tables"/>
        </>
    )
}